/*
* Created on Jan 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import TableHeadFieldComponent from "./TableHeadFieldComponent";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {useEffect, useState} from "react";
import no_data_svg from "../../../static/img/illustration/illustration-no-data.svg";
import {useTranslation} from "react-i18next";

const TableContentComponent = ({
                                   table_head_fields, table_data, row_component: RowComponent, doRefresh, disPatcher,
                                   search, table_ui, translate, isOwner, permissions=null, empty_data=null,
                                   data_table_name='', css_with_context_wrapper=true, table_height='100%', state=null
}) => {
    const { t } = useTranslation();
    const [showCheckbox, setShowCheckbox] = useState(true);
    const [isSelectAll, setIsSelectAll] = useState('');
    const isHeaderCheckboxDisabled = typeof table_ui?.table_field_checkbox_disabled === 'function'
        ? table_ui.table_field_checkbox_disabled({table_data, state, isOwner, permissions})
        : !!table_ui?.table_field_checkbox_disabled;

    const toggleSelectAll = () => {
        if (isHeaderCheckboxDisabled) {
            return false;
        }
        if ( table_data.select_box === false || table_data.select_box === 'partial') {
            disPatcher({type: 'select_all'});
            return true;
        }
        else if (table_data.select_box === true) {
            disPatcher({type: 'select_none'});
            return false
        }
    }

    const sortField = (field) => {
        let property = field;
        let sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        const head_field = table_head_fields.find(i => i.field_id === property);
        return (a,b) => {
            let val_a = property.split('.').reduce((x, y) => x[y], a);
            let val_b = property.split('.').reduce((x, y) => x[y], b);
            // let result = (val_a < val_b) ? -1 : (val_a > val_b) ? 1 : 0;
            if (head_field?.sortByHTMLRender) {
                val_a = t('@' + val_a + '@');
                val_b = t('@' + val_b + '@');
            }
            const result = (val_a < val_b) ? -1 : (val_a > val_b) ? 1 : 0;
            return result * sortOrder;
        }
    }

    const [fieldToSort, setFieldToSort] = useState(table_head_fields.filter((f)=>f.default_sort)[0]?.field_id);
    const [sortOrder, setSortOrder] = useState(table_head_fields.filter((f)=>f.default_sort)[0]?.default_sort_order);

    const toggleSortField = (field_id) => {
        let changed = false;
        setFieldToSort((prevField) => {
            if (prevField !== field_id) {
                changed = true;
                return field_id;
            }
            return prevField;
        });
        if (!changed) {
            setSortOrder((prevOrder) => {
                return (prevOrder === '-') ? '' : '-';
            });
        }
    }

    useEffect(() => {
        if (table_ui?.table_field_checkbox) {
            setShowCheckbox(table_data?.data?.some((o) => o.checked));
        }
    }, [table_data.data]);

    return (
        <div className={`${css_with_context_wrapper ? 'content-wrapper page-wrapper' : ''}`}>
            <div className="flexbox-table" data-table-name={data_table_name} style={{maxHeight: table_height}}>
                <div className="flexbox-thead">
                    { table_ui?.table_field_checkbox &&
                        <div className="thead-cell select-cell">
                            <div
                                className={`comp-checkbox no-label ${table_data.select_box === 'partial' ? 'indeterminate' : ''}`}>
                                <input type="checkbox" id="cb-all" onChange={toggleSelectAll} disabled={(!isOwner && !permissions?.invite_admin) || isHeaderCheckboxDisabled}
                                       checked={table_data.select_box || false}/>
                                <label htmlFor="cb-all" className="comp-label"> </label>
                            </div>
                        </div>
                    }
                    { table_head_fields.map((field, index) => {
                        return <TableHeadFieldComponent field={field} key={index} fieldToSort={fieldToSort} sortOrder={sortOrder} toggleSortField={toggleSortField} dispatch={disPatcher} state={state}/>
                    }) }
                </div>
                {
                    (!table_data || !table_data?.data || table_data?.data?.length === 0) && empty_data &&
                    <>
                        {empty_data}
                    </>
                }
                {
                    (!table_data || !table_data?.data || table_data?.data?.length === 0) && !empty_data &&
                    <div className="flexbox-tbody overlay-scroll os-host-flexbox">
                        <div className="no-data-screen">
                            <div className="no-data-info">
                                <div className="no-data-img"><img src={no_data_svg} alt="" /></div>
                                <div className="no-data-desc">
                                    <div className="desc-title">{t('@No Group Created.@')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {table_data && table_data?.data && table_data?.data?.length > 0 &&
                    <OverlayScrollbarsComponent
                        options={{scrollbars: {autoHideDelay: 500}, sizeAutoCapable: true}}
                        className={`flexbox-tbody overlay-scroll os-host-flexbox`}>
                        {search &&
                            table_data?.data
                                .filter((o) => table_data.search(o, table_data?.query))
                                .filter(o => table_data.hasOwnProperty('doFilter') ? table_data?.doFilter(o, state) : true)
                                .sort(sortField(sortOrder + fieldToSort))
                                .map((row_data, index) =>
                                    <RowComponent key={row_data.id || index} row_data={row_data} index={index} doRefresh={doRefresh} disPatcher={disPatcher} translate={translate} isOwner={isOwner} permissions={permissions} show_checkbox={showCheckbox} table_head_fields={table_head_fields} state={state} />
                            )
                        }
                        {!search &&
                        table_data?.data
                            .filter(o => table_data.hasOwnProperty('doFilter') ? table_data?.doFilter(o, state) : true)
                            .sort(sortField(sortOrder+fieldToSort))
                            .map((row_data, index) =>
                                <RowComponent key={row_data.id || index} row_data={row_data} index={index} doRefresh={doRefresh} disPatcher={disPatcher} translate={translate} isOwner={isOwner} permissions={permissions} table_head_fields={table_head_fields} show_checkbox={showCheckbox} state={state} />
                            )
                        }
                    </OverlayScrollbarsComponent>
                }
            </div>
        </div>
    );
};

export default TableContentComponent;
